import ApiService from '../ApiService'

const UserService = {

    async register(user) {
        try {
            return await ApiService.post('/users', user)
        } catch (error) {
            throw error
        }
    },

    async prioritizedPatient(identification, identificationType) {
        return await ApiService.customRequest({
            url: `${ApiService.farmadomiciliosApiURL}/prioritized-patient?identification=${identification}&identificationType=${identificationType}`,
            method: 'GET'
        })
    }
}

export default UserService;